import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-table-empty-state",
  imports: [MatIconModule, MatButtonModule],
  templateUrl: "./table-empty-state.component.html",
  styleUrl: "./table-empty-state.component.scss",
})
export class TableEmptyStateComponent {
  @Input() icon?: string;
  @Input() title: string = "No data found";
  @Input() message: string = "";
  @Input() actionLabel?: string;
  @Input() actionIcon?: string;

  @Output() actionClick = new EventEmitter<void>();

  onActionClick(): void {
    this.actionClick.emit();
  }
}
